export enum ReportsRouteNames {
  REPORTS = 'Reports',
  SALES_SUMMARY = 'Reports/salesSummary',
  SALES_DISTRIBUTION = 'Reports/salesDistribution',
  SALES_MIX = 'Reports/salesMix',
  REFUND = 'Reports/refundReport',
  TERMINAL_SALES = 'Reports/terminalSales',
  SALES_READING = 'Reports/salesReading',
}
